import '../style/otp-JRTgR2ej.css'
import { defineComponent as le, reactive as ie, useModel as ce, ref as i, computed as c, watch as x, nextTick as de, onMounted as pe, toRaw as fe, openBlock as u, createElementBlock as l, normalizeClass as U, toDisplayString as _, createCommentVNode as b, createVNode as $, unref as S, mergeProps as q, withCtx as K, createTextVNode as j, createElementVNode as W, Fragment as me, renderList as ve, withDirectives as ge, withKeys as D, vModelText as he } from "vue";
import { useMobileView as Te } from "./hooks/useMobileView.js";
import "x-utils";
import { BaseSizeEnum as Z, DEFAULT_SIZE as _e } from "./constant/common.js";
import "lodash-es";
import { UPDATE_MODEL_VALUE as G, UPDATE_ERROR as be, INPUT_EVENT as H, COMPLETE_EVENT as J, SEND_EVENT as ye } from "./constant/events.js";
import { useI18n as Ee } from "./hooks/useLocale.js";
import "@vueuse/core";
import "./hooks/useGlobalDark.js";
import "./layout/model/Model.js";
import "./layout/DockLocation.js";
import "./layout/Orientation.js";
import "./layout/model/TabNode.js";
import "./layout/model/TabSetNode.js";
import "./layout/model/BorderNode.js";
import { SenderTypeEnum as d } from "./constant/otp.js";
import { Button as Q } from "./button.js";
const Ie = {
  key: 0,
  class: "e-otp__label"
}, we = { key: 0 }, xe = { key: 1 }, Se = {
  key: 1,
  class: "e-otp__label"
}, Me = ["onUpdate:modelValue", "aria-label", "data-index", "onInput"], Be = {
  key: 2,
  class: "e-otp__tips"
}, Ce = {
  key: 3,
  class: "e-otp__send"
}, Ze = /* @__PURE__ */ le({
  name: "e-otp",
  __name: "otp",
  props: {
    type: {},
    modelValue: {},
    label: {},
    size: { default: Z.Medium },
    buttonProps: {},
    buttonText: {},
    buttonOnTop: { type: Boolean },
    showButton: { type: Boolean, default: !0 },
    showTips: { type: Boolean, default: !0 },
    sender: {},
    error: { default: "" },
    errorPersistent: { type: Boolean, default: !1 },
    autoFocus: { type: Boolean }
  },
  emits: [G, be, H, J, ye],
  setup(X, { emit: Y }) {
    const k = (e) => {
      if (typeof e == "string") {
        const o = e.split("");
        return o.push(...new Array(6 - o.length).fill("")), o;
      }
      return ["", "", "", "", "", ""];
    }, n = X, y = Y, { t: a } = Ee(), { isMobile: ee } = Te(window.innerWidth), s = ie({ code: k(n.modelValue ?? "") }), p = ce(n, "error", { local: !0 }), v = i(null), E = i(!1), A = i(!0), F = i(void 0), g = i(0), f = i(!1), M = i(), P = c(() => ({
      [d.Email]: a("otp.emailCode"),
      [d.SMS]: a("otp.smsCode"),
      [d.TwoFA]: a("otp.enter2FA")
    })), h = c(() => n.label ?? P.value[n.type]), te = c(() => h.value ?? P.value[d.TwoFA]), oe = c(() => {
      const e = ["e-otp"];
      return n.size !== _e && e.push(`e-otp--${n.size}`), n.buttonOnTop && e.push("e-otp--top-button"), e;
    }), L = c(() => {
      const e = ee.value ? Z.Small : n.size;
      return {
        disabled: f.value,
        text: !0,
        size: e,
        ...n.buttonProps
      };
    }), I = c(() => {
      if (n.buttonText)
        return n.buttonText;
      if (A.value)
        switch (n.type) {
          case d.Email:
            return a("otp.sendEmailCode");
          case d.SMS:
            return a("otp.sendSMSCode");
          case d.TwoFA:
            return a("otp.verify");
          default:
            return "";
        }
      return g.value > 0 ? a("otp.resendTimer", { n: g.value }) : a("otp.resend");
    }), ne = c(() => s.code.join("").replace(/[^0-9]/g, "")), N = () => {
      const e = Math.min(s.code.findIndex((o) => !o), 5);
      M.value?.querySelectorAll("input")[e].focus();
    };
    x(() => n.modelValue, (e) => {
      e || (s.code = k(e ?? ""), de(() => {
        N();
      }));
    }), x(() => n.error, (e) => {
      e && (p.value = e);
    }), x(ne, (e) => {
      y(H, e), y(G, e), e.length === 6 && y(J, e);
    });
    const B = () => {
      n.errorPersistent || (p.value = "");
    }, re = () => {
      f.value = !0, g.value = 60, F.value = setInterval(() => {
        g.value--, g.value === 0 && (f.value = !1, clearInterval(F.value));
      }, 1e3);
    }, O = (e) => {
      const o = n.sender?.responseConfig[e];
      if (!o) {
        console.warn("[OTP Component]: No response config found for code: ", e);
        return;
      }
      const { showTimeCountdown: t, message: r, disableSenderButton: m } = o;
      t && re(), r && (p.value = r), m && (f.value = !0);
    };
    let z;
    const C = async () => {
      if (B(), y("send"), E.value || !n.sender)
        return;
      f.value = !0, E.value = !0;
      const { request: e } = n.sender;
      try {
        const o = await e();
        E.value = !1, A.value = !1;
        const t = o?.code;
        O(t);
      } catch (o) {
        const t = o?.code;
        O(t), t === void 0 && (E.value = !1, f.value = !1, p.value = a("otp.sendFailed"), clearTimeout(z), z = setTimeout(() => {
          B();
        }, 1500));
      }
    }, w = (e) => e.target, V = (e) => {
      const o = w(e);
      if (o) {
        const t = o.dataset.index;
        if (t !== void 0)
          return parseInt(t, 10);
      }
      return -1;
    }, se = (e) => {
      B();
      const o = e.data;
      if (o === null) return;
      const t = o.replace(/[^0-9]/g, ""), r = V(e);
      t === "" || !s.code[r] || (s.code[r] = t, T(e, "right"));
    }, R = (e) => {
      const o = w(e), t = V(e);
      if (t > -1) {
        if (v.value !== null) {
          const r = Math.min(v.value.length, 6 - t);
          for (let m = 0; m < r; m++)
            s.code[t + m] = v.value.charAt(m);
          M.value?.querySelectorAll("input")[Math.min(5, t + r)].focus(), v.value = null;
          return;
        }
        if (s.code[t] = o.value.replace(/[^0-9]/g, ""), s.code[t] === "") return;
        T(e, "right");
      }
    }, ae = (e) => {
      if (w(e).value) {
        const t = V(e);
        if (t > -1) {
          s.code[t] = "";
          return;
        }
      }
      T(e, "left");
    }, ue = (e) => {
      e.clipboardData && e.clipboardData.getData && (v.value = e.clipboardData.getData("text").replace(/[^0-9]/g, "")), e.preventDefault(), R(e);
    }, T = (e, o) => {
      const t = w(e);
      if (t) {
        const r = o === "left" ? t.previousElementSibling : t.nextElementSibling;
        if (r === null) return;
        r.focus();
      }
    };
    return pe(() => {
      x(() => fe(n.autoFocus), (e) => {
        e && N();
      }, { immediate: !0 }), n.sender?.autoSend && C();
    }), (e, o) => (u(), l("div", {
      class: U(oe.value)
    }, [
      e.buttonOnTop ? (u(), l("div", Ie, [
        h.value ? (u(), l("div", we, _(h.value), 1)) : b("", !0),
        e.showButton && I.value ? (u(), l("div", xe, [
          $(S(Q), q(L.value, { onClick: C }), {
            default: K(() => [
              j(_(I.value), 1)
            ]),
            _: 1
          }, 16)
        ])) : b("", !0)
      ])) : h.value ? (u(), l("div", Se, _(h.value), 1)) : b("", !0),
      W("div", {
        ref_key: "inputsRef",
        ref: M,
        class: "e-otp__code-input",
        onPaste: ue
      }, [
        (u(), l(me, null, ve(6, (t) => ge(W("input", {
          key: `code-input-${t}`,
          "onUpdate:modelValue": (r) => s.code[t - 1] = r,
          type: "tel",
          inputmode: "numeric",
          "aria-label": te.value,
          maxlength: "1",
          "data-index": `${t - 1}`,
          class: U({ "has-value": s.code[t - 1] }),
          autocomplete: "one-time-code",
          onInput: (r) => R(r),
          onBeforeinput: se,
          onKeydown: D(ae, ["delete"]),
          onKeyup: [
            o[0] || (o[0] = D((r) => T(r, "left"), ["left"])),
            o[1] || (o[1] = D((r) => T(r, "right"), ["right"]))
          ]
        }, null, 42, Me), [
          [he, s.code[t - 1]]
        ])), 64))
      ], 544),
      e.showTips && S(p) ? (u(), l("div", Be, _(S(p)), 1)) : b("", !0),
      e.showButton && I.value && !e.buttonOnTop ? (u(), l("div", Ce, [
        $(S(Q), q(L.value, { onClick: C }), {
          default: K(() => [
            j(_(I.value), 1)
          ]),
          _: 1
        }, 16)
      ])) : b("", !0)
    ], 2));
  }
});
export {
  Ze as default
};
//# sourceMappingURL=otp.js.map
